import React from 'react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { MdSettings, MdLogout } from 'react-icons/md'
import {
  Menu,
  MenuButton,
  Button,
  Stack,
  Avatar,
  MenuList,
  MenuItem,
  Text,
} from '@chakra-ui/react'
import { useUser } from '../../context/UserContext'
import { useNavigate } from 'react-router-dom'
import { useLogout } from '../hooks/useLogout'

const UserMenu = () => {
  const { user } = useUser()
  const navigate = useNavigate()
  const logout = useLogout()

  const goToSettings = () => {
    navigate('/settings/account')
  }
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant="ghost"
        _focus={{ boxShadow: 'none' }}
        _focusVisible={{ boxShadow: 'none' }}
        sx={{ outline: 'none' }}
      >
        <Stack direction="row" align="center" spacing={2}>
          <Avatar size="sm" name={user?.name} src="https://bit.ly/kent-c-dworkodds" />
          <Text whiteSpace="nowrap">{user?.name}</Text>
        </Stack>
      </MenuButton>
      <MenuList>
        {window.location.pathname !== '/settings/account' ? (
          <MenuItem icon={<MdSettings />} onClick={goToSettings}>
            Settings
          </MenuItem>
        ) : null}
        <MenuItem icon={<MdLogout />} onClick={logout}>
          Logout
        </MenuItem>
      </MenuList>
    </Menu>
  )
}

export default UserMenu
